import { render, staticRenderFns } from "./AudioUploaderComponent.vue?vue&type=template&id=104af80c&"
import script from "./AudioUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
export * from "./AudioUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./AudioUploaderComponent.vue?vue&type=style&index=0&id=104af80c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports